"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESenderType = void 0;
/* eslint-disable */
//tslint:disable
let ESenderType = exports.ESenderType = /*#__PURE__*/function (ESenderType) {
  /** SMS **/
  ESenderType["Sms"] = "sms";
  /** Звонок **/
  ESenderType["Call"] = "call";
  /** E-Mail **/
  ESenderType["Email"] = "email";
  return ESenderType;
}({});